import { useState, useEffect } from 'react';
import './App.css';
import Sidebar from './components/Sidebar';
import Topbar from './components/Topbar';
import Dashboard from './components/Dashboard';
import CreateOperator from './components/CreateOperator';
import ManageOperators from './components/ManageOperators';
import CreatePricePlan from './components/CreatePricePlan';
import ManagePricePlans from './components/ManagePricePlans';
import CreateSubscription from './components/CreateSubscription';
import ManageSubscriptions from './components/ManageSubscriptions';
import Users from './components/Users';
import AdminLogin from './components/AdminLogin';
import OperatorLogin from './components/OperatorLogin';
import Countries from './components/Countries';
import MasterData from './components/MasterData';
import EmailTemplates from './components/EmailTemplates';
import Settings from './components/Settings';
import SupportSettings from './components/SupportSettings';
import TicketSettings from './components/TicketSettings';
import SMTPSettings from './components/SMTPSettings';
import GeneralSettings from './components/GeneralSettings';
import RouteSettings from './components/RouteSettings';
import TripSettings from './components/TripSettings';
import ManageTripNotifications from './components/ManageTripNotifications';
import Tickets from './components/Tickets';
import SupportTickets from './components/SupportTickets';
import CreateTicket from './components/CreateTicket';
import TicketDetails from './components/TicketDetails';
import ManageMembers from './components/ManageMembers';
import OperatorInvoices from './components/OperatorInvoices';
import OperatorDashboard from './components/OperatorDashboard';
import FinancialDashboard from './components/FinancialDashboard';
import FinancialReports from './components/FinancialReports';
import ManageDrivers from './components/ManageDrivers';
import Vendors from './components/Vendors';
import VendorFleet from './components/VendorFleet';
import VendorDocuments from './components/VendorDocuments';
import VendorContracts from './components/VendorContracts';
import VendorPricing from './components/VendorPricing';
import VendorSettings from './components/VendorSettings';
import VendorDashboard from './components/VendorDashboard';
import VendorLogin from './components/VendorLogin';
import VendorPortal from './components/VendorPortal';
import ClientLogin from './components/ClientLogin';
import ClientResetPassword from './components/ClientResetPassword';
import ClientDashboard from './components/ClientDashboard';
import OperatorClientDocuments from './components/OperatorClientDocuments';
import OperatorQuotations from './components/OperatorQuotations';
import OperatorTripList from './components/OperatorTripList';
import DriverSalaryLogs from './components/DriverSalaryLogs';
import DriverAttendance from './components/DriverAttendance';
import DriverLogins from './components/DriverLogins';
import OperatorProfile from './components/OperatorProfile';
import { fetchCountriesConfig } from './utils/formatters';



import AllVehicles from './components/AllVehicles';
import FleetDashboard from './components/FleetDashboard';
import MaintenanceOverview from './components/MaintenanceOverview';
import MaintenanceWorkshopVendor from './components/MaintenanceWorkshopVendor';
import MaintenanceJobs from './components/MaintenanceJobs';
import FuelManagement from './components/FuelManagement';
import TyreBatteryTracking from './components/TyreBatteryTracking';
import TripOperations from './components/TripOperations';
import Routes from './components/trip-operations/Routes';
import RouteStops from './components/trip-operations/RouteStops';
import Trips from './components/trip-operations/Trips';
import Passengers from './components/trip-operations/Passengers';
import PassengerAllocation from './components/trip-operations/PassengerAllocation';
import TripReports from './components/trip-operations/TripReports';
import ManageClients from './components/ManageClients';
import ClientPassengerLimits from './components/ClientPassengerLimits';
import ClientDetails from './components/ClientDetails';
import OperatorExpenses from './components/OperatorExpenses';
import SpareParts from './components/SpareParts';
import Compliance from './components/Compliance';
import MaintenanceReports from './components/MaintenanceReports';
import VehicleCostAnalysis from './components/VehicleCostAnalysis';
import AdhocTrips from './components/trip-operations/OnDemandTrip';
import ShuttleBooking from './components/ShuttleBooking';
import Availability from './components/Availability';
import PettyCash from './components/PettyCash';
import PettyCashSetup from './components/PettyCashSetup';
import TripHistory from './components/trip-operations/TripHistory';
import TripTrackingPage from './components/trip-operations/TripTrackingPage';
import BankAccounts from './components/BankAccounts';
import DriverVehicleMapping from './components/DriverVehicleMapping';
import DocumentViewer from './components/DocumentViewer';
import TestEmail from './components/TestEmail';
import RequestUpdate from './components/RequestUpdate';
import AdminUpdateRequests from './components/AdminUpdateRequests';
import AdminExpenses from './components/AdminExpenses';
import PassengerAttendanceReport from './components/PassengerAttendanceReport';
import ExpiryCommandCenter from './components/ExpiryCommandCenter';

// Read initial page from URL hash so refresh stays on the same page
const getInitialPage = () => {
  const hash = window.location.hash.replace('#', '');
  if (hash.startsWith('ticket-details/')) return 'ticket-details';
  if (hash.startsWith('create-ticket/')) return 'create-ticket';
  if (hash.startsWith('manage-members/')) return 'manage-members';
  if (hash.startsWith('view-documents/')) return 'view-documents';
  if (hash.startsWith('passenger-attendance/')) return 'passenger-attendance';
  const valid = [
    'dashboard', 'create-operator', 'manage-operators', 'create-price-plan', 'price-plans',
    'create-subscription', 'manage-subscriptions', 'users', 'countries', 'master-data',
    'email-templates', 'manage-templates', 'manage-campaigns', 'settings', 'ticket-settings', 'smtp-settings', 'general-settings', 'route-settings', 'trip-settings',
    'tickets', 'create-ticket', 'ticket-details', 'manage-members',
    'fleet-management', 'fleet-dashboard', 'all-vehicles', 'vehicle-cost-analysis', 'driver-vehicle-mapping', 'vendors', 'vendor-fleet', 'vendor-pricing', 'vendor-contracts', 'vendor-documents', 'vendor-settings', 'vendor-dashboard',
    'maintenance-overview', 'maintenance-workshop-vendor', 'maintenance-jobs', 'fuel-management', 'tyres-battery', 'compliance', 'spare-parts', 'maintenance-reports',
    'drivers', 'driver-logins', 'driver-attendance', 'driver-salary-logs', 'vendor-drivers', 'operator-login', 'superadmin-login', 'vendor-login', 'client-login',

    'operator-dashboard', 'operator-trip-list', 'operator-invoices', 'operator-quotations', 'operator-expenses', 'expense-categories', 'payment-methods', 'trip-status', 'vehicle-types', 'vehicle-status', 'fuel-types', 'service-types', 'compliance-types', 'document-types', 'driver-status', 'operator-finance-vendors', 'operator-financial-reports', 'financial-dashboard', 'bank-accounts',
    'petty-cash', 'petty-cash-setup', 'client-portal', 'vendor-portal', 'client-reset-password', 'support-tickets', 'support-settings', 'request-update', 'admin-update-requests',
    'trip-operations', 'routes', 'route-stops', 'trips', 'trip-history', 'trip-tracking', 'passengers', 'passenger-allocation', 'trip-reports', 'adhoc-trips', 'shuttle-booking', 'manage-trip-notifications', 'availability', 'manage-clients', 'client-passenger-limits', 'client-details', 'client-documents', 'operator-profile',
    'view-documents', 'admin-expenses', 'test-email', 'expiry-command-center'
  ];
  const pagePart = hash.split('/')[0].split('?')[0];
  if (pagePart && valid.includes(pagePart)) return pagePart;

  // Final fallback
  const savedUser = localStorage.getItem('ops-user');
  if (savedUser) {
    try {
      const u = JSON.parse(savedUser);
      if (u.userType === 'operator') return 'operator-dashboard';
      if (u.userType === 'admin') return 'dashboard';
    } catch (e) {}
  }
  return 'operator-login';
};



function App() {
  const [isDark, setIsDark] = useState(false);
  const [activePage, setActivePage] = useState(getInitialPage);
  const [editOperator, setEditOperator] = useState(null);
  const [editPricePlan, setEditPricePlan] = useState(null);
  const [editTicket, setEditTicket] = useState(null);
  const [user, setUser] = useState(null);
  const [operatorDetails, setOperatorDetails] = useState(null);
  const [operatorSubscription, setOperatorSubscription] = useState('Active');
  const [loading, setLoading] = useState(true);
  const [sidebarOpen, setSidebarOpen] = useState(true);

  useEffect(() => {
    const savedUser = localStorage.getItem('ops-user');
    if (savedUser) {
      setUser(JSON.parse(savedUser));
    }
    setLoading(false);

    // Fetch dynamic countries configuration once globally
    fetchCountriesConfig();

    const handleHash = () => {
      setActivePage(getInitialPage());
    };
    window.addEventListener('hashchange', handleHash);
    return () => window.removeEventListener('hashchange', handleHash);
  }, []);

  useEffect(() => {
    if (user && user.operatorId && user.userType !== 'admin') {
      Promise.all([
        fetch(`/api/operators/${user.operatorId}`).then(res => res.json()),
        fetch(`/api/subscriptions/operator/${user.operatorId}`).then(res => res.json())
      ])
      .then(([opData, subData]) => {
        setOperatorDetails(opData);
        if (subData && subData.length > 0) {
          setOperatorSubscription(subData[0].status);
        } else {
          setOperatorSubscription('Inactive'); // No subscription found
        }
      })
      .catch(err => console.error("Error fetching operator/sub details:", err));
    } else if (user && user.userType === 'admin') {
      setOperatorDetails(null);
      setOperatorSubscription('Active');
    } else {
      setOperatorDetails(null);
      setOperatorSubscription('Active');
    }
  }, [user]);

  // Global click interceptor to block mutations when subscription is inactive
  useEffect(() => {
    if (operatorSubscription !== 'Active' && user && user.userType !== 'admin') {
      const interceptor = (e) => {
        let el = e.target;
        while(el && el !== document) {
            if (el.tagName === 'BUTTON' || el.tagName === 'A' || el.getAttribute('role') === 'button' || (el.tagName === 'INPUT' && el.type === 'submit')) {
                const text = el.innerText?.toLowerCase() || '';
                const cls = el.className?.toString().toLowerCase() || '';
                
                // Allow navigation, viewing, canceling, logging out
                if (cls.includes('nav') || cls.includes('tab') || cls.includes('view') || cls.includes('cancel') || cls.includes('back') || cls.includes('close') || cls.includes('logout') || text === 'view' || text === 'cancel' || text === 'back' || text === 'close') {
                    return; 
                }
                
                // Block mutations
                if (
                    text.includes('add') || text.includes('create') || text.includes('save') || 
                    text.includes('submit') || text.includes('delete') || text.includes('edit') || 
                    text.includes('update') || text.includes('import') || text.includes('export') ||
                    cls.includes('add') || cls.includes('save') || cls.includes('delete') || cls.includes('edit') || cls.includes('action') || cls.includes('submit') || cls.includes('btn-primary') || cls.includes('md-save-btn')
                ) {
                    e.stopPropagation();
                    e.preventDefault();
                    alert("No active contracts. All your performance will be blocked, please contact the superadmin.");
                    return false;
                }
            }
            el = el.parentNode;
        }
      };
      document.addEventListener('click', interceptor, true);
      return () => document.removeEventListener('click', interceptor, true);
    }
  }, [operatorSubscription, user]);

  useEffect(() => {
    const isClientOrVendor = user?.userType === 'client' || user?.userType === 'vendor';
    if (operatorDetails && operatorDetails.companyName && isClientOrVendor) {
      document.title = `${operatorDetails.companyName} | Portal`;
    } else {
      document.title = 'Opsmaticz – Intelligent Fleet Operations';
    }
  }, [operatorDetails, user]);

  const handleLogin = (userData) => {
    setUser(userData);
    if (userData.userType === 'vendor') {
      setActivePage('vendor-portal');
    } else if (userData.userType === 'client') {
      setActivePage('client-portal');
    } else if (userData.userType === 'operator') {
      goTo('operator-dashboard');
    } else {
      goTo('dashboard');
    }
  };

  const handleLogout = () => {
    const type = user?.userType;
    localStorage.removeItem('ops-user');
    setUser(null);
    if (type === 'admin') {
      goTo('superadmin-login');
    } else if (type === 'vendor') {
      goTo('vendor-login');
    } else if (type === 'client') {
      goTo('client-login');
    } else {
      goTo('operator-login');
    }
  };

  const goTo = (page, id = null, extra = null) => {
    let hash = page;
    if (id && extra) {
      hash = `${page}/${id}/${extra}`;
    } else if (id) {
      hash = `${page}/${id}`;
    }
    window.location.hash = hash;
    setActivePage(page);
  };

  // ... (rest of the logic remains same until return)

  if (loading) return null;

  if (!user) {
    if (activePage === 'view-documents') {
      const driverId = window.location.hash.split('/')[1];
      return <DocumentViewer driverId={driverId} />;
    }
    if (activePage === 'client-reset-password') {
      return <ClientResetPassword onGoLogin={() => { setActivePage('client-login'); window.location.hash = 'client-login'; }} />;
    }
    if (activePage === 'superadmin-login') {
      return <AdminLogin onLogin={handleLogin} />;
    }
    if (activePage === 'vendor-login') {
      return <VendorLogin onLogin={handleLogin} />;
    }
    if (activePage === 'client-login') {
      return <ClientLogin onLogin={handleLogin} />;
    }
    return <OperatorLogin onLogin={handleLogin} />;
  }

  // Vendor portal: full-screen, no operator shell
  if (user?.userType === 'vendor') {
    return <VendorPortal vendor={user} onLogout={handleLogout} operatorDetails={operatorDetails} />;
  }

  // Client portal: full-screen, no operator shell
  if (user?.userType === 'client') {
    if (activePage === 'trip-tracking') {
      const tripId = window.location.hash.split('/')[1];
      return <TripTrackingPage tripId={tripId} onBack={() => goTo('client-portal')} />;
    }
    return <ClientDashboard client={user} onLogout={handleLogout} operatorDetails={operatorDetails} onNavigate={goTo} />;
  }

  // Allow logged in users to also view documents without shell if they hit the route
  if (activePage === 'view-documents') {
    const driverId = window.location.hash.split('/')[1];
    return <DocumentViewer driverId={driverId} />;
  }

  const renderPage = () => {
  const hasPermission = (perm) => {
    return true; // Giving all permissions to everyone temporarily as requested
  };

  const NoPermissionView = () => (
    <div style={{ padding: 40, textAlign: 'center', color: '#64748b' }}>
      <h2 style={{ color: '#ef4444', marginBottom: 10 }}>Access Denied</h2>
      <p>You do not have permission to view this page. Please contact your system administrator.</p>
    </div>
  );

    // Inject user permissions into components if needed
    switch (activePage) {
      case 'driver-salary-logs':
        return <DriverSalaryLogs user={user} operatorDetails={operatorDetails} />;
      case 'driver-attendance':
        return <DriverAttendance user={user} operatorDetails={operatorDetails} />;

      case 'create-price-plan':
        if (user?.userType !== 'admin' && !user?.permissions?.includes('Create Price Plan') && !user?.permissions?.includes('Edit Price Plan')) {
          return user?.userType === 'operator' ? (
            <OperatorDashboard user={user} operatorDetails={operatorDetails} onNavigate={goTo} />
          ) : (
            <Dashboard user={user} />
          );
        }
        return (
          <CreatePricePlan
            user={user}
            editPlan={editPricePlan}
            onSaved={() => {
              setEditPricePlan(null);
              goTo('price-plans');
            }}
          />
        );
      case 'price-plans':
        if (!hasPermission('View Price Plans')) return <NoPermissionView />;
        return (
          <ManagePricePlans
            user={user}
            onEdit={(plan) => {
              setEditPricePlan(plan);
              goTo('create-price-plan');
            }}
            onCreate={() => goTo('create-price-plan')}
          />
        );
      case 'countries':
        if (!hasPermission('View Countries')) return <NoPermissionView />;
        return <Countries user={user} />;
      case 'master-data':
        return <MasterData user={user} />;
      case 'email-templates':
      case 'manage-templates':
        if (!hasPermission('View Email Templates')) return <NoPermissionView />;
        return <EmailTemplates user={user} />;
      case 'manage-campaigns':
        return (
          <div style={{ padding: 40, color: '#64748b', fontSize: 16.71 }}>
            <h2 style={{ marginBottom: 8, color: '#1e293b' }}>Manage Campaigns</h2>
            <p>Coming soon — campaign management will be available here.</p>
          </div>
        );
      case 'settings':
        if (!hasPermission('Manage Settings')) return <NoPermissionView />;
        return <Settings onNavigate={goTo} />;
      case 'ticket-settings':
        return <TicketSettings user={user} />;
      case 'smtp-settings':
        return <SMTPSettings user={user} />;
      case 'general-settings':
        return <GeneralSettings />;
      case 'route-settings':
        return <RouteSettings />;
      case 'trip-settings':
        return <TripSettings />;
      case 'request-update':
        return <RequestUpdate user={user} />;
      case 'create-operator':
        if (user?.userType !== 'admin' && !user?.permissions?.includes('Create Operator') && !user?.permissions?.includes('Edit Operator')) {
          return user?.userType === 'operator' ? (
            <OperatorDashboard user={user} operatorDetails={operatorDetails} onNavigate={goTo} />
          ) : (
            <Dashboard user={user} />
          );
        }
        return (
          <CreateOperator
            user={user}
            editOperator={editOperator}
            onSaved={() => {
              setEditOperator(null);
              goTo('manage-operators');
            }}
          />
        );
      case 'test-email':
        return <TestEmail operatorDetails={operatorDetails} />;
      case 'manage-operators':
        if (!hasPermission('View Operators')) return <NoPermissionView />;
        return <ManageOperators
          user={user}
          onEdit={(op) => {
            setEditOperator(op);
            goTo('create-operator');
          }}
          onManageMembers={(op) => goTo('manage-members', op._id)}
        />;
      case 'create-subscription':
        if (user?.userType !== 'admin' && !user?.permissions?.includes('Create Subscription')) {
          return user?.userType === 'operator' ? (
            <OperatorDashboard user={user} operatorDetails={operatorDetails} onNavigate={goTo} />
          ) : (
            <Dashboard user={user} />
          );
        }
        return <CreateSubscription />;
      case 'manage-subscriptions':
        if (!hasPermission('View Subscriptions')) return <NoPermissionView />;
        return <ManageSubscriptions user={user} onCreate={() => goTo('create-subscription')} />;
      case 'admin-update-requests':
        if (!hasPermission('View Subscriptions')) return <NoPermissionView />;
        return <AdminUpdateRequests />;
      case 'admin-expenses':
        if (!hasPermission('View Dashboard')) return <NoPermissionView />;
        return <AdminExpenses user={user} />;
      case 'users':
        if (!hasPermission('View Users')) return <NoPermissionView />;
        return <Users user={user} />;
      case 'tickets':
        if (!hasPermission('View Tickets')) return <NoPermissionView />;
        return <Tickets user={user}
          onEdit={(ticket) => {
            setEditTicket(ticket);
            goTo('create-ticket');
          }}
          onReply={(ticket) => {
            setEditTicket(ticket);
            goTo('ticket-details', ticket._id);
          }}
          onCreate={() => {
            setEditTicket(null);
            goTo('create-ticket');
          }} />;
      case 'support-tickets':
        return <SupportTickets context="operator" userDetails={user} />;
      case 'create-ticket':
        return <CreateTicket
          key={editTicket?._id || 'new'}
          editTicket={editTicket}
          user={user}
          onSaved={() => {
            setEditTicket(null);
            goTo('tickets');
          }}
          onCancel={() => {
            setEditTicket(null);
            goTo('tickets');
          }}
        />;
      case 'ticket-details':
        return <TicketDetails
          ticket={editTicket}
          user={user}
          onBack={() => {
            setEditTicket(null);
            goTo('tickets');
          }}
          onSaved={() => {
            // refresh ticket data if needed or just go back
            goTo('tickets');
          }}
        />;
      case 'support-settings':
        return <SupportSettings userDetails={user?.userType === 'operator' ? operatorDetails : user} onBack={() => goTo('settings')} />;
      case 'manage-members':
        const opId = window.location.hash.split('/')[1];
        return <ManageMembers
          operatorId={opId}
          onBack={() => goTo('manage-operators')}
        />;
      case 'fleet-dashboard':
      case 'fleet-management':
        return <FleetDashboard user={user} onNavigate={goTo} operatorDetails={operatorDetails} />;
      case 'all-vehicles':
        const editVehicleId = window.location.hash.split('/')[1];
        return <AllVehicles user={user} operatorDetails={operatorDetails} editVehicleId={editVehicleId} />;
      case 'driver-vehicle-mapping':
        return <DriverVehicleMapping user={user} operatorDetails={operatorDetails} />;
      case 'vehicle-cost-analysis':
        return <VehicleCostAnalysis user={user} operatorDetails={operatorDetails} />;
      case 'maintenance-overview':
        return <MaintenanceOverview user={user} onNavigate={goTo} operatorDetails={operatorDetails} />;
      case 'maintenance-workshop-vendor':
        return <MaintenanceWorkshopVendor user={user} operatorDetails={operatorDetails} />;
      case 'maintenance-jobs':
        return <MaintenanceJobs user={user} operatorDetails={operatorDetails} />;
      case 'fuel-management':
        return <FuelManagement user={user} operatorDetails={operatorDetails} />;
      case 'tyres-battery':
        return <TyreBatteryTracking user={user} operatorDetails={operatorDetails} />;
      case 'compliance':
        return <Compliance user={user} operatorDetails={operatorDetails} />;
      case 'spare-parts':
        return <SpareParts user={user} operatorDetails={operatorDetails} />;
      case 'maintenance-reports':
        return <MaintenanceReports user={user} operatorDetails={operatorDetails} />;
      case 'drivers':
        const driverId = window.location.hash.split('/')[1];
        return <ManageDrivers user={user} operatorDetails={operatorDetails} editDriverId={driverId} />;
      case 'driver-logins':
        const logDriverId = window.location.hash.split('/')[1];
        return <DriverLogins user={user} driverId={logDriverId} onBack={() => goTo('drivers')} />;
      case 'vendor-drivers':
        const vDriverId = window.location.hash.split('/')[1];
        return <ManageDrivers user={user} operatorDetails={operatorDetails} vendorOnly={true} editDriverId={vDriverId} />;






      case 'vendors':
        return <Vendors user={user} operatorDetails={operatorDetails} />;
      case 'vendor-dashboard':
        return <VendorDashboard user={user} operatorDetails={operatorDetails} />;
      case 'vendor-fleet':
        return <VendorFleet user={user} operatorDetails={operatorDetails} />;
      case 'vendor-documents':
        return <VendorDocuments user={user} operatorDetails={operatorDetails} />;
      case 'vendor-contracts':
        return <VendorContracts user={user} operatorDetails={operatorDetails} />;
      case 'vendor-pricing':
        return <VendorPricing user={user} operatorDetails={operatorDetails} />;
      case 'vendor-settings':
        return <VendorSettings user={user} operatorDetails={operatorDetails} />;

      case 'manage-clients':
        return <ManageClients user={user} onNavigate={goTo} operatorDetails={operatorDetails} />;

      case 'client-passenger-limits':
        return <ClientPassengerLimits user={user} operatorDetails={operatorDetails} />;

      case 'client-details': {
        const hashSegments = window.location.hash.replace('#', '').split('/');
        const clientId = hashSegments[1];
        const tab = hashSegments[2] || 'basic';
        return <ClientDetails clientId={clientId} initialTab={tab} onBack={() => goTo('manage-clients')} />;
      }

      case 'passenger-attendance': {
        const payload = window.location.hash.split('/');
        const attClientId = payload[1];
        const attContactEmail = decodeURIComponent(payload[2]);
        return <PassengerAttendanceReport clientId={attClientId} contactEmail={attContactEmail} onBack={() => goTo('client-details', attClientId)} />;
      }

      case 'client-documents':
        return <OperatorClientDocuments user={user} operatorDetails={operatorDetails} />;

      /* Operator pages */
      case 'operator-profile':
        return <OperatorProfile user={user} operatorDetails={operatorDetails} />;
      case 'operator-dashboard':
        return <OperatorDashboard user={user} operatorDetails={operatorDetails} onNavigate={(page, status) => {
          window.location.hash = status ? `${page}/${status}` : page;
          setActivePage(page);
        }} />;
      case 'operator-trip-list': {
        const tripStatus = window.location.hash.replace('#', '').split('/')[1] || 'Scheduled';
        return <OperatorTripList user={user} status={tripStatus} onBack={() => goTo('operator-dashboard')} onNavigate={goTo} />;
      }
      case 'operator-invoices':
        return <OperatorInvoices user={user} operatorDetails={operatorDetails} />;
      case 'operator-quotations':
        return <OperatorQuotations user={user} operatorDetails={operatorDetails} />;
      case 'expense-categories':
      case 'payment-methods':
      case 'trip-status':
      case 'vehicle-types':
      case 'vehicle-status':
      case 'fuel-types':
      case 'service-types':
      case 'compliance-types':
      case 'document-types':
      case 'driver-status':
        const tab = activePage === 'expense-categories' ? 'expense-categories' : activePage;
        return <MasterData user={user} initialTab={tab} operatorDetails={operatorDetails} />;
      case 'operator-expenses':
        return <OperatorExpenses user={user} operatorDetails={operatorDetails} />;
      case 'bank-accounts':
        return <BankAccounts user={user} operatorDetails={operatorDetails} />;
      case 'operator-finance-vendors':
        return <div className="operator-page"><h1 className="op-title">Finance Vendors</h1><p>Manage finance-related vendors.</p></div>;
      case 'operator-financial-reports':
        return <FinancialReports user={user} operatorDetails={operatorDetails} />;
      case 'financial-dashboard':
        return <FinancialDashboard user={user} operatorDetails={operatorDetails} />;
      case 'petty-cash':
        return <PettyCash user={user} operatorDetails={operatorDetails} />;
      case 'petty-cash-setup':
        return <PettyCashSetup onBack={() => goTo('petty-cash')} />;
      case 'trip-operations':
        return <TripOperations user={user} />;
      case 'routes':
        return <Routes user={user} />;
      case 'route-stops':
        return <RouteStops user={user} />;
      case 'trips':
        return <Trips user={user} onNavigate={goTo} operatorDetails={operatorDetails} />;
      case 'trip-history': {
        const tripId = window.location.hash.split('/')[1];
        return <TripHistory tripId={tripId} user={user} onBack={() => goTo('trips')} />;
      }
      case 'trip-tracking': {
        const tripId = window.location.hash.split('/')[1];
        const isClient = user?.userType === 'client';
        return <TripTrackingPage tripId={tripId} onBack={() => goTo(isClient ? 'client-portal' : 'operator-trip-list/Ongoing')} />;
      }
      case 'passengers':
        return <Passengers user={user} />;
      case 'passenger-allocation':
        return <PassengerAllocation user={user} />;
      case 'trip-reports':
        return <TripReports user={user} />;
      case 'adhoc-trips':
        return <AdhocTrips user={user} operatorDetails={operatorDetails} />;
      case 'shuttle-booking':
        return <ShuttleBooking user={user} />;
      case 'manage-trip-notifications':
        return <ManageTripNotifications user={user} operatorDetails={operatorDetails} />;
      case 'availability':
        return <Availability user={user} />;
      case 'expiry-command-center':
        return <ExpiryCommandCenter user={user} onNavigate={goTo} />;

      case 'dashboard':
      default:
        if (user?.userType === 'admin' && !hasPermission('View Dashboard')) return <NoPermissionView />;
        if (user?.userType === 'operator') {
          return <OperatorDashboard user={user} operatorDetails={operatorDetails} onNavigate={(page, status) => {
            window.location.hash = status ? `${page}/${status}` : page;
            setActivePage(page);
          }} />;
        }
        return <Dashboard user={user} operatorDetails={operatorDetails} />;
    }
  };

  return (
    <div className={`app-shell ${isDark ? 'theme-dark' : 'theme-light'} ${sidebarOpen ? '' : 'sidebar-closed'} ${user?.userType === 'admin' ? 'superadmin-shell' : ''}`}>
      {sidebarOpen && (
        <Sidebar activePage={activePage} onNavigate={(page) => {
          if (page !== 'create-operator') setEditOperator(null);
          if (page !== 'create-price-plan') setEditPricePlan(null);
          goTo(page);
        }} user={user} onLogout={handleLogout} operatorDetails={operatorDetails} />
      )}
      <div className="main-content">
        {operatorSubscription !== 'Active' && user && user.userType !== 'admin' && (
          <div style={{ background: '#fef2f2', borderBottom: '1px solid #f87171', color: '#991b1b', padding: '12px 20px', textAlign: 'center', fontSize: '14.5px', fontWeight: '600', letterSpacing: '0.01em', zIndex: 100, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', flexShrink: 0 }}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>
            No active contracts. All your performance will be blocked, please contact the superadmin.
          </div>
        )}
        <Topbar isDark={isDark} onToggleTheme={() => setIsDark(d => !d)} onLogout={handleLogout} user={user} operatorDetails={operatorDetails} onNavigate={goTo} onToggleSidebar={() => setSidebarOpen(!sidebarOpen)} />
        <div className="page-content" key={activePage}>
          {renderPage()}
        </div>

      </div>
    </div>
  );
}

export default App;